'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var APIVERSION = null;

var Company = function Company(baseUrl, version, axios) {
    APIVERSION = '/' + version;

    return {
        createCompany: function createCompany(company) {
            return axios.put(APIVERSION + '/companies', company).then(function (res) {
                if (!res.data.id) {
                    return "Company not saved, ID missing";
                } else {
                    return res;
                }
            }).catch(function (e) {
                return e;
            });
        },

        updateCompany: function updateCompany(company) {
            if (!company.id) {
                return 'Missing company ID, cannot update';
            }
            return axios.put(APIVERSION + '/companies', company).then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        },

        getCompanies: function getCompanies() {
            return axios.get(APIVERSION + '/companies').catch(function (error) {
                return Promise.reject(error);
            }).then(function (res) {
                if (res.status == 200) {
                    return Promise.resolve(res);
                } else {}
            });
        },

        getCompany: function getCompany(COMPANY_ID) {
            return axios.get(APIVERSION + '/companies/' + COMPANY_ID).then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        },

        deleteCompany: function deleteCompany(COMPANY_ID) {
            return axios.delete(APIVERSION + '/companies/' + COMPANY_ID).then(function (res) {
                return res;
            }).catch(function (e) {
                e;
            });
        },

        getUsers: function getUsers(COMPANY_ID) {
            return axios.get(APIVERSION + '/companies/' + COMPANY_ID + '/users').then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        },

        getMyApps: function getMyApps(COMPANY_ID) {
            return axios.get(APIVERSION + '/companies/' + COMPANY_ID + '/applicenses').then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        }
    };
};
exports.default = Company;


function checkForRequiredValues(arrayOFValuesRequired, ObjectPassed) {
    var result = true;
    arrayOFValuesRequired.forEach(function (check) {
        var test = _.includes(check, ObjectPassed);
        if (!test) {
            result = false;
        }
    });
    return result;
}